import styled from 'styled-components';
import Colors from 'assets/Colors.js';
import Constants from 'helpers/constants';

const BodyContainer = styled.div`
  width: 97%;
  margin: 0 auto;
  border-radius: 5px;
  margin-top: 38px;
  ${(props) => (!props.editing ? 'padding-left: 23px;' : '')}
  padding-right: 23px;
  ${(props) =>
    !props.editing &&
    'box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04),0px 0px 1px rgba(0, 0, 0, 0.04); '}
  display: flex;
  flex-direction: column;
  @media (max-width: ${Constants.pxMobileBreakPoint}px) {
    flex-direction: column;
  }
`;

const SectionTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  display: flex;
  align-items: center;
  letter-spacing: 0.01em;
  color: ${Colors.primary};
`;
const Line = styled.div`
  background: ${Colors.background_dividers};
  height: 1px;
  width: 100%;
`;

const secondLine = styled.div`
  background: ${Colors.divider};
  height: 1px;
  width: 100%;
`;

const textSwitch = styled.div`
  width: 35px;
  margin-right: 25px;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_primary};
`;

const text = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: ${Colors.text_primary};
`;

const spacePadding = styled.div`
  padding-bottom: 8px;
`;

export default {
  SectionTitle,
  Line,
  secondLine,
  BodyContainer,
  textSwitch,
  text,
  spacePadding,
};
